// Set header position based on page scroll
var scrollPosition = window.scrollY;
$(window).on('scroll', function () {
    if ($(window).width() >= 992) {
        $('.header').setDataAttribute('position', (scrollPosition < 100) ? 'top' : 'body');
        $('.header').setDataAttribute('collapsed', false);
        scrollPosition = window.scrollY;
    }
});

// Toggle header collapse
$('.header').on('click', '[data-event="toggle-secondary"]', function (e) {
    var header = $(e.delegateTarget),
        isCollapsed = header.data('collapsed');

    header.setDataAttribute('collapsed', !isCollapsed);
});

// Show sub-menus
$('.header .secondary').on('mouseover', 'a', function (e) {
    var limit = $(this).closest('[class^="col-"]').index(),
        target = $(this).data('target'),
        lists = $(e.delegateTarget).find('[class^="col-"]');

    if ($(window).width() >= 992) {
        lists
            .filter((index, list) => index > limit)
            .find('ul')
            .hide();

        if ($(target).length) {
            $(target).show();
        }
    }
});

// Show mobile sub-menus
$('.header .secondary').on('click', 'a', function (e) {
    var target = $(this).data('collapse');

    if ($(window).width() < 992) {
        var collapse = new bootstrap.Collapse($(target), {
            toggle: true,
            parent: $(target).data('bs-parent'),
        })

        collapse.toggle();
    }
});

// Unused links
$('header').on('click', 'a[href^="#"]', function (e) {
    e.preventDefault();
});

// Responsive dropdown
$('header').on('click', 'a[data-target]', function (e) {
    if ($(window).width() < 992) {
        e.preventDefault();
    }
});
